import { CustomerModel } from "../types/crm-contact";

export function setAppToken(token:string){
  sessionStorage.setItem("apiToken",token)
}

export const getAppToken = ()=>{
  return sessionStorage.getItem("apiToken");
}

export function setVendorId(vendorId:string){
  sessionStorage.setItem("vendorId",vendorId)
}

export const getVendorId = ()=>{
  return sessionStorage.getItem("vendorId");
}
export function setUserToken(userToken: string) {
  sessionStorage.setItem("userToken", userToken);
}
 
export const getUserToken = () => {
  return sessionStorage.getItem("userToken") ?? "";
}

export function setUserName(userName:string){
  sessionStorage.setItem("userName",userName)
}

export const getUserName = ()=>{
  return sessionStorage.getItem("userName")??"";
}

export function setFirmName(firmName:string){
  sessionStorage.setItem("firmName",firmName)
}

export const getFirmName = ()=>{
  return sessionStorage.getItem("firmName")??"";
}

export function setImageURL(imageURL:string){
  sessionStorage.setItem("imageURL",imageURL)
}

export const getImageURL = ()=>{
  return sessionStorage.getItem("imageURL")??"";
}

// User bilgileri (Ticket sistemi için)
export function setUserFirstName(firstName: string) {
  sessionStorage.setItem("userFirstName", firstName);
}

export const getUserFirstName = () => {
  return sessionStorage.getItem("userFirstName") ?? "";
};

export function setUserLastName(lastName: string) {
  sessionStorage.setItem("userLastName", lastName);
}

export const getUserLastName = () => {
  return sessionStorage.getItem("userLastName") ?? "";
};

export function setUserEmail(email: string) {
  sessionStorage.setItem("userEmail", email);
}

export const getUserEmail = () => {
  return sessionStorage.getItem("userEmail") ?? "";
};

export function setUserRef(userRef: string) {
  sessionStorage.setItem("userRef", userRef);
}

export const getUserRef = () => {
  return sessionStorage.getItem("userRef") ?? "";
};

export function setUserPhone(phone: string) {
  sessionStorage.setItem("userPhone", phone);
}

export const getUserPhone = () => {
  return sessionStorage.getItem("userPhone") ?? "";
};





export const customersToSession = (customers) => {
  sessionStorage.setItem("customers",customers);
}

export const customersFromSession = ()=>{
  return sessionStorage.getItem("customers")??"";
}


export const customerListFilterToSession = (select:string) => {
  sessionStorage.setItem("customerFilter",select);
}

export const customerListFilterFromSession = ()=>{
  return sessionStorage.getItem("customerFilter")??1;
}

export const customerListSelectToSession = (select:string) => {
  sessionStorage.setItem("customerSelect",select);
}

export const customerListSelectFromSession = ()=>{
  return sessionStorage.getItem("customerSelect")??"";
}


export const campaignListStatusToSession = (select:string) => {
  sessionStorage.setItem("campaignListStatus",select);
}

export const campaignListStatusFromSession = ()=>{
  return sessionStorage.getItem("campaignListStatus")??1;
}


export const salesmanListStatusToSession = (select:string) => {
  sessionStorage.setItem("salesmanListStatus",select);
}

export const salesmanListStatusFromSession = ()=>{
  return sessionStorage.getItem("salesmanListStatus")??1;
}

export const routesListStatusToSession = (select:string) => {
  sessionStorage.setItem("routesListStatus",select);
}

export const routesListStatusFromSession = ()=>{
  return sessionStorage.getItem("routesListStatus")??1;
}

export const segmentsListStatusToSession = (select:string) => {
  sessionStorage.setItem("segmentsListStatus",select);
}

export const segmentsListStatusFromSession = ()=>{
  return sessionStorage.getItem("segmentsListStatus")??1;
}

export const imageStatusToSession = (select:string) => {
  sessionStorage.setItem("imageListStatus",select);
}

export const imageStatusFromSession = ()=>{
  return sessionStorage.getItem("imageListStatus")??0;
}




 const customersUpdateSess = (code:number,customerM:CustomerModel)=>{
  // Önce session'dan mevcut listeyi alın
const existingListString = sessionStorage.getItem("customers")??"[]";

// JSON formatındaki string'i JavaScript nesnesine dönüştürün
const existingList = JSON.parse(existingListString);

// Güncellenecek öğenin customerCode değeri
const targetcustomerCode = code;

// Güncellenecek öğenin index'ini bulun
const targetIndex = existingList.findIndex(customer => customer.customerCode == targetcustomerCode);

if (targetIndex !== -1) {
    // Öğe bulunduysa güncellemeyi yapın
    existingList[targetIndex]= customerM;

    // Güncellenmiş listeyi JSON formatına dönüştürün
    const updatedListString = JSON.stringify(existingList);

    // Session'da güncellenmiş listeyi saklayın
    sessionStorage.setItem("customers", updatedListString);

} else {
}

}